import { render, staticRenderFns } from "./strategy.vue?vue&type=template&id=20d7fa44&scoped=true"
import script from "./strategy.vue?vue&type=script&lang=ts"
export * from "./strategy.vue?vue&type=script&lang=ts"
import style0 from "./strategy.vue?vue&type=style&index=0&id=20d7fa44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d7fa44",
  null
  
)

export default component.exports